/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useMutation } from '@apollo/client';
import PageForm from './form';
import { UPDATE_CONTENT_RELATED_SITE_SETTINGS } from '../../../queries/site';

interface IUpdateSiteSettingsProps {
  data: {
    id: string;
    languages: string[];
  };
  refetch: () => void;
}

export const UpdateSiteSettings: React.FC<IUpdateSiteSettingsProps> = ({
  data,
  refetch,
}) => {
  const [updateSite] = useMutation(UPDATE_CONTENT_RELATED_SITE_SETTINGS, {
    onCompleted: () => refetch(),
  });

  return <PageForm data={data} mutateData={updateSite} />;
};
